import { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { apiUrl } from "../../config/config.js";
import { useNavigate } from "react-router-dom/dist/index.js";

function Dashboard() {
	const navigate = useNavigate();
	const [tournaments, setTournaments] = useState([]);
	const [participants, setParticipants] = useState([]);
	const [statsData, setStatsData] = useState([]);

	useEffect(() => {
		fetchDashboardData();
	}, []);

	const fetchDashboardData = async () => {
		try {
			const responseTournaments = await fetch(apiUrl + "/tournaments-all", {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (responseTournaments.status === 200) {
				let data = await responseTournaments.json();
				console.log(data);
				setTournaments(data.data);
			}
			const responseParticipants = await fetch(apiUrl + "/participants", {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (responseParticipants.status === 200) {
				let data = await responseParticipants.json();
				setParticipants(data.data);
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
		}
	};

	useEffect(() => {
		fetch("/assets/data/dashboard/stats.json")
			.then((res) => res.json())
			.then((result) => {
				setStatsData(result);
			});
	}, []);

	const counts = {
		"TOTAL TORNEOS": tournaments.length,
		"TOTAL DE PARTICIPANTES": participants.length,
	};

	return (
		<div>
			<div className="row">
				{statsData &&
					statsData.length > 0 &&
					statsData.map((stat, index) => (
						<div className="col-xl-3 col-lg-6 " key={index}
							onClick={() => navigate(stat.navigate)}
							style={{ cursor: "pointer" }}>
							<Card className="mb-3">
								<CardBody>
									<div className="d-flex fw-bold small mb-3">
										<span className="flex-grow-1">{stat.title}</span>
									</div>
									<div className="row align-items-center mb-2">
										<div className="col-7">
											<h3 className="mb-0">{counts[stat.title]}</h3>
										</div>
									</div>
								</CardBody>
							</Card>
						</div>
					))}
			</div>
		</div>
	);
}

export default Dashboard;
